<!-- MaFranchise.vue -->
<template>
    <div class="title-page">
        <h1 class="title">Tout les utilisateurs</h1>
        <!-- <router-link to="/mondomicil-admin/ajouter-compte" class="button outline normal">Créer un
            utilisateur</router-link> -->
    </div>
    <div v-if="users.length == 0" class="card white">
        <div style="text-align: center; padding: 50px">
            <h2>Aucun CIL créé pour le moment</h2>
            <img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png" alt="Aucun cil trouvé" />
        </div>
    </div>
    <div v-else-if="filteredUsers.length == 0" class="card white">
        <div style="text-align: center; padding: 50px">
            <h2>Aucun CIL trouvé</h2>
            <img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png" alt="Aucun cil trouvé" />
        </div>
    </div>
    <div v-else class="head">
        <div class="cils">CILs</div>
        <div class="name">Nom</div>
        <div class="address">Adresse</div>
        <div class="email">Email</div>
        <div class="status">Status</div>
        <div class="action">&nbsp;</div>
    </div>
    <div class="logement-list">
        <div class="logement-line" v-for="user in filteredUsers" :key="user.ID">
            <div class="cils">{{ user.propertyCount }}</div>
            <div class="name">{{ user.firstname || "Non fourni" }} {{ user.lastname }}</div>
            <div class="address">{{ user.address }}</div>
            <div class="email">{{ user.email }}</div>
            <div class="status">{{ user.status }}</div>
            <div class="action">
                <button class="button fill normal" @click="openViewPopup(user)">Modifier</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "AllUsers",
    props: ['searchQuery'],
    components: {},
    data() {
        return {
            users: [],
        };
    },
    created() {
        this.fetchAllUsers();
    },
    methods: {
        async fetchAllUsers() {
            try {
                const response = await fetch(process.env.VUE_APP_API_URL + "admin/users", { method: "GET", credentials: "include", });
                const data = await response.json();
                if (data.error) {
                    window.location.href = "/login";
                } else {
                    this.users = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                }
            } catch (error) {
                this.message = "Une erreur est survenue.";
            }
        },
        openViewPopup(cil) {
            this.showViewCIL = cil;
            this.showViewPopup = true;
        },
        closeViewPopup() {
            this.fetchAllCILs();
            this.showViewCIL = {};
            this.showViewPopup = false;
        },
    },
    computed: {
        filteredUsers() {
            const query = this.searchQuery?.toLowerCase() || "";
            return this.users.filter(user =>
                (user.firstname?.toLowerCase() ?? "").includes(query) ||
                (user.lastname?.toLowerCase() ?? "").includes(query) ||
                (user.email?.toLowerCase() ?? "").includes(query)
            );
        }
    }
};
</script>


<style scoped>
.head {
    display: flex;
    margin-bottom: 30px;
}

.head>div {
    padding-left: 25px;
    font-size: 14px;
    font-weight: bold;
    color: #a7a7a7;
}

.head>div:nth-child(-n + 4) {
    position: relative;
}

.head>div:nth-child(-n + 4)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 25px;
    background-color: #ccc;
}

.head .cils {
    min-width: 50px;
}

.head .name,
.head .address,
.head .email {
    min-width: 225px;
}

.head .address {
    flex: 1;
}

.head .status {
    width: 100px;
}

.head .action {
    width: 125px;
}

.logement-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.logement-line {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 15px;
    filter: drop-shadow(0 0 5px #d3d3d3);
    height: 60px;
}

.logement-line>div {
    padding: 0 25px;
}

.logement-line>div:nth-child(-n + 4) {
    position: relative;
}

.logement-line>div:nth-child(-n + 4)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 35px;
    background-color: #ccc;
}

.logement-line .cils {
    min-width: 25px;
}

.logement-line .name,
.logement-line .address,
.logement-line .email {
    min-width: 200px;
    font-weight: bold;
}

.logement-line .address {
    flex: 1;
}

.logement-line .status {
    min-width: 75px;
}

.logement-line .action {
    width: 100px;
}
</style>
